// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GhwZ","colBig":"styles_colBig__2JG7_","colSmall":"styles_colSmall__188t7","shopifyNameWrapper":"styles_shopifyNameWrapper__34h7F"};